/**
 * Reads a small JSON file the page's own server serves beside it. A server without the file
 * answers 404 or its index.html, so a file that is absent or does not parse reads as null.
 */

import type { z } from 'zod';

/** The parsed file, or null. Never rejects. */
export async function fetchServedFile<S extends z.ZodType>(
    path: string, schema: S,
): Promise<z.output<S> | null> {
    try {
        const resp = await fetch(path, { cache: 'no-store' });
        if (!resp.ok) {
            return null;
        }
        const parsed = schema.safeParse(JSON.parse(await resp.text()));
        return parsed.success ? parsed.data : null;
    } catch {
        return null;
    }
}
